import type {
  EventDraft,
  EventFormErrors,
  EventFormValues,
  RetreatEvent,
} from '../types/events'
import { isValidISODate } from './eventDates'

export const DEFAULT_ADDRESS = '13 Kvutzat Avraham, Kfar Pines'

export function toFormValues(event: RetreatEvent | null): EventFormValues {
  return {
    tagline: event?.tagline ?? '',
    title: event?.title ?? '',
    subtitle: event?.subtitle ?? '',
    performers: event?.performers ?? '',
    eventDate: event?.eventDate ?? '',
    doorsTime: event?.doorsTime ?? '',
    showTime: event?.showTime ?? '',
    address: event ? event.address ?? '' : DEFAULT_ADDRESS,
    posterUrl: event?.posterUrl ?? '',
    posterAlt: event?.posterAlt ?? '',
  }
}

function clean(value: string): string | null {
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

export function toDraft(values: EventFormValues, published: boolean): EventDraft {
  const title = values.title.trim()
  const posterUrl = clean(values.posterUrl)
  return {
    tagline: clean(values.tagline),
    title,
    subtitle: clean(values.subtitle),
    performers: clean(values.performers),
    eventDate: values.eventDate,
    doorsTime: clean(values.doorsTime),
    showTime: clean(values.showTime),
    address: clean(values.address),
    posterUrl,
    posterAlt: posterUrl ? clean(values.posterAlt) ?? `Poster for ${title}` : null,
    published,
  }
}

export function validateEventForm(values: EventFormValues): EventFormErrors {
  const errors: EventFormErrors = {}
  if (!values.title.trim()) errors.title = 'Give the event a title.'
  if (!values.eventDate) {
    errors.eventDate = 'Pick the date of the event.'
  } else if (!isValidISODate(values.eventDate)) {
    errors.eventDate = 'That date doesn’t look right.'
  }
  return errors
}
